import { HatElement } from '@/components/hat-element.js';

class HatNavButton extends HatElement {
  constructor() {
    super();

    const title = this.getAttribute("title");
    const path = this.getAttribute("href");

    this.root.innerHTML = `
      <style>
        .nav-link {
            text-decoration: none;
            font-size: 1em;
            font-weight: bold;
            color: black;
            padding: 8px 16px;
            border-radius: 8px;
            transition: background 0.3s ease, color 0.3s ease;
            white-space: nowrap;
            background: whitesmoke;
            border: 1px solid lightgray;
        }

        .nav-link:hover {
            background: #f0f0f0;
            color: #333;
            border: 1px solid #cce5ff;
        }
      </style>

      <a href="${path}" class="nav-link" title="${title}" data-link>
        <slot></slot>
      </a>
    `;
  }
}

customElements.define("hat-nav-button", HatNavButton);